// services/notificationService.js
import axiosInstance from '../axiosConfig/instance';

export const fetchNotifications = async (user) => {
    try {
        const ShopID = localStorage.getItem('ShopID');
        const response = await axiosInstance.post('notification', { 
            user: { ...user, ShopID } // دمج user و ShopID في كائن واحد
        });
        
        
        return response.data.data || []; // تأكد من عدم وجود undefined
    } catch (error) {
        console.error("Error fetching notifications:", error);
        return [];
    }
};
